import React from 'react';
import NavBar from './NavBar';
import OptionsButtons from './OptionsButtons';
import { useDetectMobile } from '../../../helpers/detectDevice';
import { Box } from '@chakra-ui/react';

export default function Header() {
  const mobile = useDetectMobile();

  return (
    <>
      <NavBar />
      <Box bg="transparent" py="1em">
        {mobile && <OptionsButtons isMobile noMarginBottom />}
      </Box>
    </>
  );
}
